import { render } from "./AsModal.vue?vue&type=template&id=629eb942&ts=true"
import script from "./AsModal.vue?vue&type=script&lang=ts"
export * from "./AsModal.vue?vue&type=script&lang=ts"

import "./AsModal.vue?vue&type=style&index=0&id=629eb942&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__